/* eslint-disable import/no-unresolved */
import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Form } from 'Umbraco.Headless.Forms.Presentation/packages/react/src';
import { isEmpty } from 'lodash';
import { StyledForm } from './styles/Form.styled';
import { Container } from './styles/Container.styled';
import { Row } from './styles/Row.styled';
import { Column } from './styles/Column.styled';
import { SectionForm, SectionCaption, EnquiryFormHeading } from './styles/EnquiryFormBlock.styled';
import { DWTCContext } from '../utils/context';
import PlanEventSliderBlock from './PlanEventSliderBlock';
import Loading from './Loading';

export default function UmbracoForm({ data, id, dir }) {
  const isBrowser = typeof window !== 'undefined';
  const [isDone, setIsDone] = useState(false);
  const [messageOnSubmit, setMessageOnSubmit] = useState('');
  const [loading, setLoading] = useState(true);
  const isArabic = dir === 'rtl';
  const isPlanEvent = isBrowser && window.location.pathname.includes('plan-event');
  const isIphone = isBrowser && /^((?!chrome|android).)*iPhone/i.test(window.navigator.userAgent);

  const initailState = {
    _id: '',
    indicator: '',
    name: '',
    nextLabel: '',
    previousLabel: '',
    submitLabel: '',
    disableDefaultStylesheet: false,
    fieldIndicationType: '',
    hideFieldValidation: false,
    messageOnSubmit: '',
    showValidationSummary: false,
    pages: [],
  };

  const [form, setForm] = useState(initailState);
  const { description, umbracoFormId } = data;
  const { cssClass } = React.useContext(DWTCContext);

  // console.log(form);

  useEffect(() => {
    const loadForm = () => {
      const config = {
        method: 'get',
        url: `https://api.umbraco.io/forms/${umbracoFormId}`,
        headers: {
          'umb-project-alias': process.env.GATSBY_FORMS_UMBRACO_ENVIRONMENT,
          'Api-Key': process.env.GATSBY_UMBRACO_FORMS_API_KEY,
        },
      };
      setLoading(true);
      axios(config)
        .then((response) => {
          setForm(response.data);
          setMessageOnSubmit(response.data.messageOnSubmit);
          setLoading(false);
        })
        .catch(() => {
          // console.log(error);
          setLoading(false);
        });
    };

    loadForm();
  }, []);

  const handleSubmit = (formData) => {
    const el = document.getElementById('country');
    const attendees = document.getElementById('howManyAttendeesExpected');
    let newFormData = isEmpty(el) ? formData : { ...formData, countryLabel: el.ariaLabel };

    newFormData = isEmpty(attendees)
      ? newFormData
      : { ...newFormData, howManyAttendeesExpected: attendees.value };

    const config = {
      method: 'POST',
      url: `https://api.umbraco.io/forms/${umbracoFormId}/entries`,
      headers: {
        'umb-project-alias': process.env.GATSBY_FORMS_UMBRACO_ENVIRONMENT,
        'Api-Key': process.env.GATSBY_UMBRACO_FORMS_API_KEY,
        'Content-Type': 'application/json',
      },
      data: JSON.stringify(newFormData),
    };
    setLoading(true);
    axios(config)
      .then(() => {
        setIsDone(true);
        setLoading(false);
        setForm(initailState);
        const dataLayer = window && window?.dataLayer ? window.dataLayer : [];
        dataLayer.push({ event: `form-submit-${umbracoFormId}` });
      })
      .catch(() => {
        // console.log(error);
      });
    return false;
  };
  return (
    <SectionForm
      id={id}
      className={cssClass}
      dir={dir}
      isLoading={loading}
      isPlanEvent={isPlanEvent}
      isArabic={isArabic}
      isIphone={isIphone}
    >
      <Container>
        <Row>
          <Column>
            {loading ? (
              <Loading />
            ) : (
              <StyledForm dir={dir}>
                {!isDone && (
                  <EnquiryFormHeading>
                    <SectionCaption dir={dir} className="title_sec">
                      {description}
                    </SectionCaption>
                  </EnquiryFormHeading>
                )}
                {isDone || <PlanEventSliderBlock dir={dir} />}
                <Form
                  form={form}
                  onSubmit={handleSubmit}
                  recaptchaPublicKey={process.env.GATSBY_RECAPTCHA_SITE_KEY}
                  isArabic={isArabic}
                  formName="Contact"
                />
              </StyledForm>
            )}
            {isDone && (
              <EnquiryFormHeading className="thank-you__container">
                <SectionCaption className="thank-you__msg" dir={dir}>
                  {messageOnSubmit}
                </SectionCaption>
              </EnquiryFormHeading>
            )}
          </Column>
        </Row>
      </Container>
    </SectionForm>
  );
}
